import React from 'react';
// Constants
import {
  CHATURBATE_URL,
  CompanyEmailAddress,
  CompanyName,
  DISCORD_URL,
  LOYALFANS_URL,
  PER_MIN_AMOUNT,
  THRONE_URL,
} from '../../utils/constants/Constants';
import {
  CLIPS_PAGE_URL,
} from '../../utils/constants/Routes';
// Components
import CallToActionOne from '../cta/CallToActionOne';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
// Data
import { smallPayPins } from '../../utils/data/LinksData';
import WhatIOfferComponent from '../general/WhatIOfferComponent';

const inPersonSessions = [
  { label: 'Short Sessions', price: '$200 - $300' },
  { label: '1 Hour', price: '$450' },
  { label: '90 Minutes', price: '$600' },
  { label: '2 Hours', price: '$750' },
  { label: '3 Hours', price: '$1000' },
  { label: 'All Day (6+ Hours)', price: '$2000 minimum' },
  { label: 'Overnight', price: '$2500 minimum' },
  { label: 'FMTY', price: '$2000 minimum' },
  { label: 'Cash Meets', price: '$150 minimum' },
  { label: 'Shopping', price: '$100 deposit, $200 minimum spent' },
];

const customs = [
  { label: 'Muscle Photo', price: '$5 each' },
  { label: 'Custom Photo', price: '$10 each' },
  { label: 'Dick Rating', price: '$8 each' },
  { label: 'Custom Video', price: `$${PER_MIN_AMOUNT} / minute` },
  { label: 'One To One Call', price: '$10 / minute' },
];

function SessionsPageMainContainer() {
  return (
    <main role='main' className='pt-24'>
      <WhatIOfferComponent />

      {/* Social cta */}
      <SocialMediaCtaComponent />
    </main>
  );
}

function MenuSection({ title, items }) {
  return (
    <article className='grid uppercase'>
      <section className='grid grid-cols-reg w-full gap-x-6'>
        {title === 'In-Person Sessions' ? (
          <>
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                In-Person Sessions
              </h3>
            </div>
            <div className='grid md:hidden items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                In-Person <br /> Sessions
              </h3>
            </div>
          </>
        ) : title === 'Online Sessions' ? (
          <>
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                Online Sessions
              </h3>
            </div>
            <div className='grid md:hidden items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                Online <br /> Sessions
              </h3>
            </div>
          </>
        ) : title === 'Extended Sessions' ? (
          <>
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                Extended Sessions
              </h3>
            </div>
            <div className='grid md:hidden items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                Extended <br /> Sessions
              </h3>
            </div>
          </>
        ) : title === 'Custom Content' ? (
          <>
            <div className='hidden md:grid items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                Custom Content
              </h3>
            </div>
            <div className='grid md:hidden items-center'>
              <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
                Custom <br /> Content
              </h3>
            </div>
          </>
        ) : (
          <div>
            <h3 className='text-3xl text-colour8 font-titleFont tracking-widest'>
              {title}
            </h3>
          </div>
        )}

        <div className='grid items-center'>
          <div
            className='h-[2px] -mt-4 bg-colour8'
            role='separator'
            aria-hidden='true'
          ></div>
        </div>
      </section>
      <ul className='mt-4 space-y-2'>
        {items.map((item, index) => (
          <li key={index}>
            <div className='grid grid-flow-col gap-2 text-end justify-between'>
              <div className='text-left'>{item.label}</div>
              {title !== 'Online Sessions' && (
                <div>
                  <span className=''>{item.price}</span>
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
      {title === 'Online Sessions' && (
        <div className='text-center'>
          <div>
            <p>
              Online Session Prices are Subject to Change due to availability
            </p>
          </div>
          <div>
            <p>Contact Me for price information</p>
          </div>
        </div>
      )}
    </article>
  );
}

export default SessionsPageMainContainer;
